module.exports = __webpack_public_path__ + "static/media/cowbell.a50027da.svg";